import React from 'react';

import './Card.scss';

export type CardProps = {
    title?: string;
    className?: string;
} & React.ComponentPropsWithoutRef<'div'>;

export const Card: React.FC<CardProps> = ({ title, className, children }) => {
    return (
        <div className={`card ${className ?? ''}`}>
            {title && (
                <div className="card-title">
                    <h3>{title}</h3>
                </div>
            )}
            <div className="card-body">{children}</div>
        </div>
    );
};
